import loadable from '../../src/modules/dynamic/loadable';

export { loadable };
